(function () {
  'use strict';
  if (!window.YangluuSelection || document.documentElement.dataset.iqReady) return;
  document.documentElement.dataset.iqReady = 'true';
  const $ = selector => document.querySelector(selector);
  const $$ = selector => Array.from(document.querySelectorAll(selector));
  const parse = value => { try { return JSON.parse(value); } catch (_) { return null; } };
  const strings = parse($('#iq-strings')?.textContent || '{}') || {};
  const text = key => strings[key] || key;
  let storage;
  try { storage = window.localStorage; } catch (_) { storage = { getItem() { throw Error('disabled'); }, setItem() { throw Error('disabled'); } }; }
  const store = window.YangluuSelection.create(storage, window.location.origin);
  const dialog = $('#iq-selection-dialog');
  let opener;
  const params = new URLSearchParams(window.location.search);
  if (params.has('mode')) store.setMode(params.get('mode'));

  // Hooks reuse an installed analytics service; no customer contact data is emitted.
  function track(event, details = {}) {
    const payload = { enquiry_type: store.snapshot().mode, selected_count: store.snapshot().items.length, ...details };
    window.dispatchEvent(new CustomEvent('yangluu:enquiry', { detail: { event, ...payload } }));
    if (typeof window.gtag === 'function') window.gtag('event', event, payload);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...payload });
  }
  function announce(message) { if ($('#iq-announcer')) $('#iq-announcer').textContent = message; }
  function make(tag, content, className) {
    const el = document.createElement(tag);
    if (content) el.textContent = content;
    if (className) el.className = className;
    return el;
  }
  function absolute(item) { return new URL(item.url, location.origin).href; }
  let selectedPhoto = 1;
  let selectedPhotoImage = $('#ip-main-image')?.src || '';
  const fieldMap = [['country','iq-country'],['name','iq-name'],['email','iq-email'],['phone','iq-phone'],['company','iq-company'],['website','iq-website'],['timing','iq-timeline'],['requirements','iq-message']];
  function rowsText(items) { return window.YangluuSelection.rowsText(items, location.origin, text('photo')); }
  function productRecord(record) {
    if (!record) return record;
    if (!$('#ip-main-image')) return record;
    return { ...record, photo: selectedPhoto, image: selectedPhotoImage || record.image, qty: $('#ip-request-quantity')?.value || 1 };
  }
  function updateWhatsApp() {
    const state = store.snapshot();
    const fields = fieldMap.map(([label,id]) => [text(label), $('#' + id)?.value || '']);
    $$('[data-iq-whatsapp]').forEach(link => {
      const d = link.dataset;
      let items = state.items;
      if (d.waProductTitle && d.waProductUrl) {
        const saved = state.items.find(item => absolute(item) === d.waProductUrl);
        items = [{ title: d.waProductTitle, url: d.waProductUrl, qty: Math.min(9999, Math.max(1, Math.floor(Number($('#ip-request-quantity')?.value || saved?.qty) || 1))), photo: selectedPhoto, image: selectedPhotoImage || saved?.image || '' }];
      }
      const body = window.YangluuSelection.message({ intro: d.waIntro || '', typeLabel: d.waTypeLabel || '', itemsLabel: d.waItemsLabel || '', mode: state.mode, items, origin: location.origin, fields, labels: strings });
      link.href = 'https://wa.me/15185368054?text=' + encodeURIComponent(body);
    });
  }
  function render() {
    const state = store.snapshot();
    $$('[data-count]').forEach(el => { el.textContent = state.items.length; });
    $$('[data-inquiry-mode], #iq-mode').forEach(el => { el.value = state.mode; });
    $$('[data-save-product]').forEach(button => {
      const item = parse(button.dataset.saveProduct);
      const saved = !!item && state.items.some(row => row.id === String(item.id));
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? text('saved') : text('save')) + ': ' + (item?.title || ''));
      button.textContent = button.classList.contains('iq-add') ? (saved ? '✓' : '+') : (saved ? text('saved') : text('save'));
    });
    const list = $('#iq-selection-items');
    if (list) {
      list.replaceChildren();
      if (!state.items.length) list.append(make('p', text('empty')));
      state.items.forEach(item => {
        const row = make('div', '', 'iq-selection-row');
        if (item.image) { const img = make('img'); img.src = item.image; img.alt = ''; img.width = 60; img.height = 70; row.append(img); }
        else row.append(make('span'));
        const copy = make('div'); const link = make('a', item.title); link.href = item.url; copy.append(link);
        if (item.photo) copy.append(make('p', text('photo') + ' ' + item.photo));
        const remove = make('button', text('remove')); remove.type = 'button'; remove.dataset.removeId = item.id; remove.setAttribute('aria-label', text('remove') + ': ' + item.title); copy.append(make('br'), remove); row.append(copy);
        const field = make('label', text('quantity')); const input = make('input'); input.type = 'number'; input.min = '1'; input.max = '9999'; input.step = '1'; input.value = item.qty; input.dataset.quantityId = item.id; input.setAttribute('aria-label', text('quantity') + ': ' + item.title); field.append(input); row.append(field); list.append(row);
      });
    }
    const summary = $('#iq-form-selection');
    if (summary) {
      summary.replaceChildren();
      if (!state.items.length) summary.append(make('p', text('empty')));
      state.items.forEach(item => { const p = make('p', '', 'iq-form-item'); const a = make('a', item.title + ' × ' + item.qty + (item.photo ? ' · ' + text('photo') + ' ' + item.photo : '')); a.href = item.url; p.append(a); summary.append(p); });
    }
    if ($('#iq-selected-input')) $('#iq-selected-input').value = rowsText(state.items);
    if ($('#iq-storage-note')) { $('#iq-storage-note').hidden = state.persistent; $('#iq-storage-note').textContent = text('storage_notice'); }
    ['business', 'wholesale', 'drop'].forEach(group => {
      const visible = group === 'business' ? true : state.mode === (group === 'drop' ? 'dropshipping' : group);
      $$('.iq-' + group + '-field').forEach(field => { field.hidden = !visible; field.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = !visible; input.required = false; }); });
    });
    const total = state.items.reduce((sum, item) => sum + item.qty, 0);
    if ($('#iq-total-summary')) { $('#iq-total-summary').hidden = !total; $('#iq-total-summary').textContent = text('total') + ': ' + total; }
    if ($('#iq-total-input')) $('#iq-total-input').value = total || '';
    if ($('#iq-minimum-note')) $('#iq-minimum-note').hidden = state.mode !== 'wholesale' || !total || total >= 5;
    updateWhatsApp();
  }
  function openSelection() {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    opener = document.activeElement; render(); dialog.showModal(); return true;
  }
  function saveProduct(item) {
    const result = store.add(item);
    if (result === 'existing' && item && item.photo) { store.setPhoto(item.id, item.photo, item.image); store.setQuantity(item.id, item.qty); }
    render();
    if (result === 'full') { openSelection(); if ($('#iq-storage-note')) { $('#iq-storage-note').hidden = false; $('#iq-storage-note').textContent = text('max_notice'); } }
    else if (result === 'added') { announce(text('saved_notice')); track('shortlist_add', { product_id: item.id }); }
    return result;
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a'); if (!target) return;
    if (target.matches('[data-photo-index]')) {
      event.preventDefault();
      selectedPhoto = Number(target.dataset.photoIndex);
      selectedPhotoImage = new URL(target.dataset.photoSrc, location.origin).href;
      const main = $('#ip-main-image');
      if (main) { main.src = selectedPhotoImage; main.removeAttribute('srcset'); main.alt = target.querySelector('img')?.alt || ''; }
      $$('[data-photo-index]').forEach(el => el.setAttribute('aria-current', String(el === target)));
      if ($('#ip-photo-number')) $('#ip-photo-number').textContent = text('photo') + ' ' + selectedPhoto;
      if ($('#ip-full-photo')) $('#ip-full-photo').href = target.href;
      const record = parse($('[data-enquire-product]')?.dataset.enquireProduct);
      if (record) store.setPhoto(record.id, selectedPhoto, selectedPhotoImage);
      render();
    }
    if (target.matches('[data-open-selection]')) { if (openSelection()) event.preventDefault(); }
    if (target.matches('[data-close]')) dialog?.close();
    if (target.matches('[data-save-product]')) { event.preventDefault(); saveProduct(productRecord(parse(target.dataset.saveProduct))); }
    if (target.matches('[data-enquire-product]')) {
      const result = saveProduct(productRecord(parse(target.dataset.enquireProduct)));
      if (result === 'full' || result === 'invalid') { event.preventDefault(); return; }
      const url = new URL(target.href); url.searchParams.set('mode', store.snapshot().mode); target.href = url.href;
    }
    if (target.matches('[data-remove-id]')) { store.remove(target.dataset.removeId); render(); dialog?.querySelector('[data-remove-id], [data-close]')?.focus(); }
    if (target.matches('[data-clear-selection]')) { store.clear(); render(); target.focus(); }
    if (target.matches('[data-mode]')) { store.setMode(target.dataset.mode); render(); }
    if (target.matches('[data-iq-whatsapp]')) { updateWhatsApp(); track('whatsapp_click', { product_context: !!target.dataset.waProductTitle }); }
  });
  document.addEventListener('change', event => {
    const target = event.target;
    if (target.matches('[data-quantity-id]')) { store.setQuantity(target.dataset.quantityId, target.value); const id = target.dataset.quantityId; render(); const replacement = $$('[data-quantity-id]').find(input => input.dataset.quantityId === id); replacement?.focus(); }
    if (target.matches('[data-inquiry-mode],#iq-mode')) { store.setMode(target.value); render(); }
  });
  document.addEventListener('input', event => { if (event.target.closest('#InquiryForm') || event.target.id === 'ip-request-quantity') updateWhatsApp(); });
  dialog?.addEventListener('close', () => { opener?.focus(); });
  window.addEventListener('storage', event => { if (event.key === window.YangluuSelection.key) { store.reload(); render(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) { store.reload(); render(); } });
  const form = $('#InquiryForm');
  form?.addEventListener('submit', () => { if (!$('#iq-message').value.trim()) $('#iq-message').value = text('default_message'); track('inquiry_form_submit'); });
  if ($('[data-inquiry-success]')) track('inquiry_form_success');
  render();
  // Resolve a product deep link when local storage is unavailable or a link is shared.
  const handle = params.get('style');
  if (form && handle && /^[a-z0-9][a-z0-9-]*$/.test(handle) && !store.snapshot().items.some(item => item.handle === handle)) {
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }).then(response => {
      if (!response.ok) throw Error('Unavailable'); return response.json();
    }).then(item => {
      if (item.handle !== handle) return;
      const image = item.featured_image || '';
      saveProduct({ id: String(item.id), handle: item.handle, title: item.title, url: root + 'products/' + item.handle, image: image.startsWith('//') ? 'https:' + image : image });
    }).catch(() => { announce(text('selected_unavailable')); if ($('#iq-message') && !$('#iq-message').value) $('#iq-message').value = 'I am enquiring about this style: ' + location.origin + '/products/' + handle; });
  }
})();
